import React from "react";
import { DataRequestType } from "@/core/types/dataRequestsTypes";
import { wrapper } from "@/core/store/store";
import providePageBySlug from "@/connectors/fcWordpress/thunks/ProvidePageBySlug";
import providePostById from "@/connectors/fcWordpress/thunks/utils/ProvidePostById";
import provideGlobal from "@/connectors/fcWordpress/provideGlobal";
import { PageContent } from "@/components/modules/Page/PageContent";
import { PostPageContent } from "@/components/modules/Post/PostPageContent";

export default function PostOrPage({ pageProps }: any) {
  return (
    <>
      {!!pageProps.page && <PageContent page={pageProps.page} />}
      {(!!pageProps.post || !!pageProps.postId) && <PostPageContent post={pageProps.post} postId={pageProps.postId} />}
    </>
  );
}

// This gets called on every request
export const getServerSideProps = wrapper.getServerSideProps<any>((store) => async (context) => {
  const slug = Array.isArray(context.query.postOrPage) ? context.query.postOrPage : [];

  context.res.setHeader("Cache-Control", "public, s-maxage=10, stale-while-revalidate=59");

  const locale = context.locale === "default" ? process.env.NEXT_PUBLIC_DEFAULT_API_LANGUAGE_CODE! : context.locale!;

  if (isNaN(typeof slug[0] === "string" ? parseInt(slug[0]) : slug[0])) {
    const [, page] = await Promise.all([
      provideGlobal(locale, store.dispatch),
      providePageBySlug(
        {
          type: DataRequestType.PAGE_BY_SLUG,
          language: locale,
          sign: { slug: slug[0] },
        },
        store.dispatch
      ),
    ]);

    if (!page) {
      return {
        notFound: true,
      };
    }
    return { props: { post: null, page: page?.data || null } };
  }

  const [, post] = await Promise.all([
    provideGlobal(locale, store.dispatch),
    providePostById(
      {
        type: DataRequestType.POST_BY_ID,
        language: locale,
        sign: { id: slug[0], slug: slug[1] },
      },
      store.dispatch
    ),
  ]);

  if (!post) {
    return {
      notFound: true,
    };
  }

  return {
    props: {
      post: post?.data || null,
      postId: parseInt(slug[0]),
      page: null,
    },
  };
});
